// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'companies/SET_FILTER_OPTIONS' as const
export const SET_COMPANIES = 'companies/SET_COMPANIES' as const
export const SET_ACTIVE_FILTERS = 'companies/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'companies/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'companies/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'companies/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_COMPANY_RECORD = 'companies/UPDATE_COMPANY_RECORD' as const
export const ADD_COMPANY = 'companies/ADD_COMPANY' as const
export const APPEND_COMPANIES = 'companies/APPEND_COMPANIES' as const
export const UPDATE_COMPANY_ROUND = 'companies/UPDATE_COMPANY_ROUND' as const
export const REMOVE_COMPANY_FROM_LIST = 'companies/REMOVE_COMPANY_FROM_LIST' as const
